import React from "react";
import useDocumentTitle from "../../assets/utils/useDocumentTitle";
import { Breadcrumb, Footer, Header, Sidebar } from "../../components";
import "./style.scss";

function Phiburan() {
  useDocumentTitle("Pajak Hiburan- BAPENDA BEKASI");
  return (
    <div className="page">
      <Header active="Phiburan" />

      {/* main */}
      <main className="main-sb">
        <section className="content">
          <Breadcrumb path="Jenis Pelayanan / Pajak Hiburan" />
          <div className="page-title-wrapper">
            <div className="page-title">PBJT ATAS JASA KESENIAN DAN HIBURAN</div>
          </div>

          {/* <p className="page-text">
            Dalam rangka pelaksanaan Peraturan Pemerintah Nomor 18 Tahun 2016 tentang Perangkat Daerah dan Peraturan Menteri Dalam Negeri Nomor 97 Tahun 2016 tentang Perangkat Daerah Provinsi DKI Jakarta, maka berdasarkan Peraturan Gubernur
            Nomor 154 Tahun 2020 tentang Organisasi dan Tata Kerja Perangkat Daerah dibentuklah Badan Pendapatan Daerah (Bapenda) Provinsi DKI Jakarta.
          </p> */}

          <p className="subpage-title"><strong>PBJT Atas Jasa Kesenian dan Hiburan</strong></p>
          <p className="page-text">Jasa Kesenian dan Hiburan adalah jasa penyediaan atau penyelenggaraan
semua jenis tontonan, pertunjukan, permainan, ketangkasan, rekreasi,
dan/ atau keramaian untuk dinikmati.
</p>
<p className="page-text">
Jasa Kesenian dan Hiburan meliputi:<br></br>
a. tontonan film atau bentuk tontonan audio visual lainnya yang
dipertontonkan secara langsung di suatu lokasi tertentu;<br></br>
b. pergelaran kesenian, musik, tari, dan/atau busana;<br></br>
c. kontes kecantikan;<br></br>
d. kontes binaraga;<br></br>
e. pameran;<br></br>
f. pertunjukan sirkus, akrobat, dan sulap;<br></br>
g. pacuan kuda dan perlombaan kendaraan bermotor;<br></br>
h. permainan ketangkasan;<br></br>
i. olahraga permainan dengan menggunakan tempat/ruang dan/atau
peralatan dan perlengkapan untuk olahraga dan kebugaran;<br></br>
j. rekreasi wahana air, wahana ekologi, wahana pendidikan, wahana
budaya, wahana salju, wahana permainan, pemancingan, agrowisata,
dan kebun binatang;<br></br>
k. panti pijat dan pijat refleksi; dan<br></br>
l. diskotek, karaoke, kelab malam, bar, dan mandi uap/spa.<br></br>
Yang dikecualikan dari Jasa Kesenian dan Hiburan adalah Jasa Kesenian dan Hiburan yang semata-mata untuk:<br></br>
a. Promosi budaya tradisional dengan tidak dipungut bayaran;<br></br>
b. Kegiatan layanan masyarakat dengan tidak dipungut bayaran; dan/atau<br></br>
c. Bentuk kesenian dan hiburan lainnya yang tidak dipungut bayaran. 
</p>
<p className="page-text">

Tarif PBJT atas Jasa Kesenian dan Hiburan ditetapkan sebagai berikut:
</p>
<p className="page-text">
A. 10% (sepuluh persen) untuk:
</p>
<p className="page-text">
1. tontonan film atau bentuk tontonan audio visual lainnya yang dipertontonkan secara langsung di suatu lokasi tertentu;<br></br>
2. pergelaran kesenian, musik, tari, dan/atau busana;<br></br>
3. kontes kecantikan;<br></br>
4. kontes binaraga;<br></br>
5. pameran;<br></br>
6. pertunjukan sirkus, akrobat, dan sulap;<br></br>
7. pacuan kuda dan perlombaan kendaraan bermotor;<br></br>
8. permainan ketangkasan;<br></br>
9. olahraga permainan dengan menggunakan tempat/ruang dan/atau peralatan dan perlengkapan untuk olahraga dan kebugaran;<br></br>
10. rekreasi wahana air, wahana ekologi, wahana pendidikan, wahana budaya, wahana salju, wahana permainan, pemancingan, agrowisata,
    dan kebun binatang; dan <br></br>
11. panti pijat dan pijat refleksi.<br></br>
</p>
<p className="page-text">
B. 5% (lima persen) untuk pagelaran kesenian, musik, tari, busana, kontes
kecantikan, dan binaraga yang berkelas lokal/tradisional;
</p>
<p className="page-text">
C. 40% (empat puluh persen) untuk diskotek, karaoke, kelab malam, bar
dan mandi uap/spa.





</p>
<p className="page-text">
DASAR HUKUM : <br></br>
<a href="https://jdih.bekasikota.go.id/peraturan-daerah/view?id=525" target="_blank" rel="noreferrer"><font color="blue">Peraturan Daerah Kota Bekasi Nomor 1 Tahun 2024 Tentang Pajak Daerah Dan Retribusi Daerah</font></a>
</p>

         
        
         
         
          
        </section>
        <Sidebar />
      </main>

      <Footer />
    </div>
  );
}

export default Phiburan;
